/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_70b5c1ac"]'><div :class='["radio-modal-cancel-btn-demo"]'><cube-checkbox-group-modal ref="__mpx_ref_checkboxModal__" title="关闭按钮配置" subtitle='你可以通过设置"cancelText"来显示关闭文案，同时将"cancelBtnAlign"设置为"right"' cancelText="关闭" cancelBtnAlign="right" :options="(options)" :values="(value)"/><cube-button @_click="onTap">checkbox-modal-cancel-btn</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_70b5c1ac"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_70b5c1ac"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_70b5c1ac"}
  /** script content **/
  require("./checkbox-modal-cancel-btn.mpx.js?isComponent&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./checkbox-modal-cancel-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcheckbox-modal-cancel-btn70b5c1ac%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_70b5c1ac"],
    ctorType: "component",
    outputPath: "components/checkbox-modal-cancel-btn70b5c1ac/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-modal/index.mpx?isComponent&outputPath=components%2Findex37cd7d2c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>